import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationJP from './locales/ja/translations.json';
import translationEN from './locales/en/translations.json';
import jobsJP from './locales/ja/jobs.json';
import jobsEN from './locales/en/jobs.json';

const resources = {
  ja: {
    translations: translationJP,
    jobs: jobsJP
  },
  en: {
    translations: translationEN,
    jobs: jobsEN
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: document.documentElement.lang || 'ja',
    fallbackLng: 'ja',
    debug: import.meta.env.DEV,
    ns: 'translations',
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export { i18n };